import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import type { IOpenClueReportOptions } from '../types';

export const GEETEST_MESSAGEAUTHENTICATION = process.env.VUE_APP_GEETEST_MESSAGEAUTHENTICATION;
export const SMS_CODE_ERROR = 9030119;
export const HUBSPOT_IFRAME_URL = 'https://js.hsforms.net/forms/embed/v2.js';
export const HUBSPOT_REGION = 'na1';

/* =============== AIR west form 配置 =============== */
const AIR_HUBSPOT_PORTAL_ID = '2149185';
const AIR_HUBSPOT_FORM_ID = 'c576825a-ecd3-4aea-bb2d-0b496d29c0f6';

/* =============== MATERIAL west form 配置 =============== */
const MATERIAL_HUBSPOT_PORTAL_ID = '2149185';
const MATERIAL_HUBSPOT_FORM_ID = 'e47b1ff1-b32e-4e35-8c04-f299dc7a172d';

/* =============== PROTECT west form 配置 =============== */
const PROTECT_HUBSPOT_PORTAL_ID = '2149185';
const PROTECT_HUBSPOT_FORM_ID = '9f91d0dd-2f7f-4ee1-884f-e7591f3ef98f';

/* =============== IP west form 配置 =============== */
const IP_HUBSPOT_PORTAL_ID = '2149185';
const IP_HUBSPOT_FORM_ID = '7ce987ce-49e6-475d-9fcf-653d392c131d';

/* =============== DISCOVERY west form 配置 =============== */
const DISCOVERY_HUBSPOT_PORTAL_ID = '2149185';
const DISCOVERY_HUBSPOT_FORM_ID = 'f2fb9316-1144-4d87-a1d6-8020a7cebca6';

/* =============== LS west form 配置 =============== */
const LS_HUBSPOT_PORTAL_ID = '2149185';
const LS_HUBSPOT_FORM_ID = 'aa43e2dd-a977-4c1d-93f9-1a363acd51ec';

/**
 * 获取升级目标套餐的表单配置映射
 * @param pkgType
 * @returns Partial<IOpenClueReportOptions>
 */
export function getTargetEditionFormConfig(pkgType: EurekaPackageType) {
  const config: Record<string, Partial<IOpenClueReportOptions>> = {
    [EurekaPackageType.AIR_COMMERCIAL]: {
      // AIR 企业版
      hubspotPortalId: AIR_HUBSPOT_PORTAL_ID,
      hubspotFormId: AIR_HUBSPOT_FORM_ID,
    },
    [EurekaPackageType.MATERIAL_COMMERCIAL]: {
      // 材料企业版
      hubspotPortalId: MATERIAL_HUBSPOT_PORTAL_ID,
      hubspotFormId: MATERIAL_HUBSPOT_FORM_ID,
    },
    [EurekaPackageType.PROTECT_COMMERCIAL]: {
      // 技术保护(Protect)企业版
      hubspotPortalId: PROTECT_HUBSPOT_PORTAL_ID,
      hubspotFormId: PROTECT_HUBSPOT_FORM_ID,
    },
    [EurekaPackageType.IP_COMMERCIAL]: {
      // 知识产权(IP)企业版
      hubspotPortalId: IP_HUBSPOT_PORTAL_ID,
      hubspotFormId: IP_HUBSPOT_FORM_ID,
    },
    [EurekaPackageType.INSIGHTS_COMMERCIAL]: {
      // 研发情报企业版
      hubspotPortalId: DISCOVERY_HUBSPOT_PORTAL_ID,
      hubspotFormId: DISCOVERY_HUBSPOT_FORM_ID,
    },
    [EurekaPackageType.LS_COMMERCIAL]: {
      // 研发情报企业版
      hubspotPortalId: LS_HUBSPOT_PORTAL_ID,
      hubspotFormId: LS_HUBSPOT_FORM_ID,
    },
  };

  return config[pkgType];
}
